export default __webpack_public_path__ + "media/images/tenant/timeline/number_3-8a48c694f62f5a20a480b3ef24bbe2b1.svg";